import ApiClient from '@afosto/api/ApiClient';

class Filters {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Upsert filters for skus
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Create or update filters for products
   * @returns {Promise}
   */
  attachFilters(body, options = {}) {
    return this.apiClient.request({
      url: `/odr/filters`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * Get a list of filter keys
   *
   * @param {Object} options - The additional request options
   * @description Returns distinct filter keys
   * @returns {Promise}
   */
  getFilterKeys(options = {}) {
    return this.apiClient.request({
      url: `/odr/filters/keys`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get a list of fiter sets
   *
   * @param {Object} options - The additional request options
   * @description Get a listing filters per sku
   * @returns {Promise}
   */
  getFilterSets(options = {}) {
    return this.apiClient.request({
      url: `/odr/filters`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get a list of filter values for a given key
   *
   * @param {string} key
   * @param {Object} options - The additional request options
   * @description Returns distinct filter values
   * @returns {Promise}
   */
  getFilterValues(key, options = {}) {
    return this.apiClient.request({
      url: `/odr/filters/keys/${key}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Search filters
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Returns a list of filters
   * @returns {Promise}
   */
  searchFilters(body, options = {}) {
    return this.apiClient.request({
      url: `/odr/search/filters`,
      method: 'post',
      data: body,
      ...options,
    });
  }
}

export const filters = new Filters();

export default Filters;
